import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '../../image/add.svg'


const _hoisted_1 = { class: "role" }
const _hoisted_2 = { style: {"margin-top":"10px"} }
const _hoisted_3 = { class: "role_add" }
const _hoisted_4 = {
  class: "role_add_left",
  style: {"width":"50%"}
}
const _hoisted_5 = { class: "role_add_left_top" }
const _hoisted_6 = { class: "role_add_left_bottom" }
const _hoisted_7 = {
  class: "role_add_right",
  style: {"width":"50%"}
}
const _hoisted_8 = { class: "role_add_right_show" }
const _hoisted_9 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.roles, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "addRole2",
          key: index
        }, [
          _createElementVNode("p", null, _toDisplayString(item.roleName), 1),
          _createVNode(_component_el_image, {
            src: item.roleImg,
            fit: "contain",
            style: {"width":"100%"}
          }, null, 8, ["src"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: ($event: any) => {
            $options.editRole(index);
            this.isUpdate = true;
          }
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("编辑")
              ])),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_popconfirm, {
              title: "确认删除?",
              onConfirm: ($event: any) => ($options.deleteRole(index))
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_button, { type: "danger" }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode("删除")
                  ])),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onConfirm"])
          ])
        ]))
      }), 128)),
      _createElementVNode("div", {
        class: "addRole",
        onClick: _cache[0] || (_cache[0] = ($event: any) => {
        this.customDraggingVisible = true;
        this.form = [];
        this.isUpdate = false;
        this.fileList = [];
      })
      }, _cache[13] || (_cache[13] = [
        _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        }, null, -1),
        _createElementVNode("p", null, "添加角色", -1)
      ]))
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: $data.customDraggingVisible,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($data.customDraggingVisible) = $event)),
      class: "custom-dragging-style",
      title: "建立角色",
      width: "1000",
      draggable: "",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_button, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => ($data.customDraggingVisible = false))
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[9] || (_cache[9] = ($event: any) => ($data.isUpdate ? $options.updateRole() : $options.addRole()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($data.isUpdate ? "编辑" : "添加"), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { style: {"margin":"10px 0"} }, "角色图片", -1)),
              _createVNode(_component_el_upload, {
                "file-list": $data.fileList,
                "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => (($data.fileList) = $event)),
                action: $options.UpdateApi,
                "list-type": "picture-card",
                "on-success": $options.handleAvatarSuccess,
                "before-upload": $options.beforeAvatarUpload,
                limit: "1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Plus)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["file-list", "action", "on-success", "before-upload"]),
              _cache[15] || (_cache[15] = _createElementVNode("div", { style: {"margin":"10px 0"} }, " 图片上传格式为 JPG/PNG/GIF，建议尺寸 1080*1920px ", -1))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_form, {
                model: $data.form,
                "label-width": "auto",
                "label-position": "top",
                style: {"width":"90%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "角色名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: $data.form.name,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.form.name) = $event)),
                        maxlength: "20"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "性别" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: $data.form.sex,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.form.sex) = $event)),
                        maxlength: "20"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "年龄" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: $data.form.age,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.form.age) = $event)),
                        maxlength: "20"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "职业" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: $data.form.profession,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.form.profession) = $event)),
                        maxlength: "20"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "特殊技能" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: $data.form.skill,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.form.skill) = $event)),
                        type: "textarea",
                        "show-word-limit": "",
                        maxlength: "200"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "角色描述" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: $data.form.desc,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.form.desc) = $event)),
                        type: "textarea",
                        "show-word-limit": "",
                        maxlength: "200"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", null, [
                _createVNode(_component_el_image, {
                  src: $data.form.img,
                  alt: "",
                  fit: "contain",
                  style: {"height":"100%"}
                }, null, 8, ["src"])
              ]),
              _createElementVNode("p", null, "角色名称:   " + _toDisplayString($data.form.name), 1),
              _createElementVNode("p", null, "性别:   " + _toDisplayString($data.form.sex), 1),
              _createElementVNode("p", null, "年龄:   " + _toDisplayString($data.form.age), 1),
              _createElementVNode("p", null, "职业:   " + _toDisplayString($data.form.profession), 1),
              _createElementVNode("p", null, "特殊技能:   " + _toDisplayString($data.form.skill), 1),
              _createElementVNode("p", null, "性格描述:   " + _toDisplayString($data.form.desc), 1),
              _cache[16] || (_cache[16] = _createElementVNode("p", null, [
                _createElementVNode("span", null, "继续")
              ], -1))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}